import React, { useState, useEffect } from "react";
import {
  Box,
  Grid,
  Button,
  TextField,
  Select,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  FormControl,
  makeStyles,
  Typography,
  Dialog,
  Drawer,
  Divider,
  List,
  ListItem,
  Avatar,
} from "@material-ui/core";
import { CircularProgress } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import PersonIcon from "@material-ui/icons/Person";
import {
  Visibility,
  Search as SearchIcon,
  ArrowDropDown,
  Refresh,
  ChevronLeft,
  ChevronRight,
  ExpandMore,
  KeyboardArrowDown,
  KeyboardArrowRight,
} from "@material-ui/icons";

import moment from "moment";
import axios from "axios";
import { blue } from "@material-ui/core/colors";
import { appUrl } from "../../../../../utils/config";
import { saveDashboardFilters, fetchAllDashboardFilters } from '../../../containers/utils/filterUtils';
import StyledDialog from "../../../../common/models/Dialog";


const useStyles = makeStyles((theme) => ({
  blueButton: {
    backgroundImage: "linear-gradient(to right, #301232, #1A2D6C, #173072)",
    color: "white",
    border: "1px solid black",
    textTransform: "none",
    borderRadius: "2rem",
    paddingLeft: "16px",
    paddingRight: "16px",
    "&:hover": {
      backgroundColor: "green",
      background: "green",
      color: "white",
      border: "1px solid green",
    },
  },
  formControl: {
    minWidth: 180,
    // backgroundColor: "#F0F0F0",
    // borderRadius: "4px 0 0 4px",
    // border: "1px solid #ccc",
    // borderRight: "none",
    // height: 40,
  },
  select: {
    height: 40,
    paddingTop: 0,
    paddingBottom: 0,
    display: "flex",
    alignItems: "center",
  },
  textField: {
    flexGrow: 1,
    height: 40,
  },
  searchButton: {
    backgroundColor: "#E25F1D",
    minWidth: 40,
    height: 40,
    borderRadius: "0 4px 4px 0",
    boxShadow: "none",
    padding: 0,
  },
  saveFiltersButton: {
    backgroundColor: "#E25F1D",
    color: "white",
    textTransform: "none",
    borderRadius: "2rem",
    padding: "6px 16px",
    "&:hover": {
      backgroundColor: "#c44d15",
    },
  },
  filterSelect: {
    minWidth: 120,
    backgroundColor: "#fff",
    border: "1px solid #ccc",
    borderRadius: "4px",
  },
  clearFilters: {
    color: "#1976d2",
    textDecoration: "underline",
    cursor: "pointer",
    fontSize: 14,
  },
  tableHeader: {
    backgroundColor: "#f5f5f5",
    fontWeight: "bold",
  },
  expandButton: {
    padding: 4,
  },
  // Drawer styles
  drawer: {
    width: 600,
    height: "100%",
    display: "flex",
    flexDirection: "column",
    backgroundColor: "#fff",
  },
  drawerHeader: {
    padding: "20px 24px 16px",
    borderBottom: "1px solid #e0e0e0",
  },
  drawerTitle: {
    fontWeight: 600,
    fontSize: "18px",
    color: "#333",
    marginBottom: "4px",
  },
  drawerSubtitle: {
    fontWeight: "500",
    fontSize: "18px",
    color: "#333",
    marginBottom: "20px",
  },
  drawerContent: {
    flex: 1,
    padding: "20px 24px",
    overflow: "auto",
  },
  memberItem: {
    padding: "12px 0",
    display: "flex",
    alignItems: "center",
  },
  avatar: {
    width: 40,
    height: 40,
    marginRight: "12px",
    backgroundColor: "#e3f2fd",
    color: "#1976d2",
  },
  memberInfo: {
    flex: 1,
  },
  memberName: {
    fontWeight: 600,
    fontSize: "14px",
    color: "#333",
    marginBottom: "2px",
  },
  memberRole: {
    fontSize: "12px",
    color: "#666",
  },
  drawerFooter: {
    padding: "16px 24px",
    display: "flex",
    justifyContent: "flex-end",
  },
  drawerCloseButton: {
    backgroundColor: "#1976d2",
    color: "#fff",
    textTransform: "none",
    fontWeight: 600,
    borderRadius: "4px",
    padding: "10px 32px",
    "&:hover": {
      backgroundColor: "#1565c0",
    },
  },
}));

// Search by options
const searchByOptions = [
  { value: "Sponsor Product Code", label: "Sponsor Product Code" },
  { value: "Sponsor Product Description", label: "Sponsor Product Description" },
  { value: "CMO", label: "CMO" },
];

const BrandDetails = () => {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [products, setProducts] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [lastSyncTime, setLastSyncTime] = useState(new Date());
  const [expandedProducts, setExpandedProducts] = useState({});
  const [initialLoad, setInitialLoad] = useState(false);

  // New states for dropdown options fetched from API
  const [productModalityOptions, setProductModalityOptions] = useState([]);
  const [productTypeOptions, setProductTypeOptions] = useState([]);
  const [loadingDropdowns, setLoadingDropdowns] = useState({
    modality: false,
    productType: false,
  });
  const [productIdPayload, setProductIdPayload] = useState({
    productModalityId: "all",
    productTypeId: "all",
  });

  const [filters, setFilters] = useState({
    searchBy: "",
    searchTerm: "",
    productModality: "All",
    productType: "All",
  });

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [saveDialogOpen, setSaveDialogOpen] = useState(false);
  const [saveDialogSuccess, setSaveDialogSuccess] = useState(true);
  const [savingFilters, setSavingFilters] = useState(false);
  const [clearingFilters, setClearingFilters] = useState(false);
  const [lastSavedFilters, setLastSavedFilters] = useState({
    searchBy: "",
    searchTerm: "",
    productModality: "All",
    productType: "All",
  });
  const [teamDrawerOpen, setTeamDrawerOpen] = useState(false);
  const [selectedTeamMembers, setSelectedTeamMembers] = useState([]);
  const [selectedBrand, setSelectedBrand] = useState("");

  // For backdrop state
  const dispatch = (action) => {
    if (action.type === "OPEN_BACKDROP") {
      // Open backdrop logic would go here
    } else if (action.type === "DESTROY_BACKDROP") {
      // Close backdrop logic would go here
    }
  };

  // Constants for backdrop dispatch
  const OPEN_BACKDROP = "OPEN_BACKDROP";
  const DESTROY_BACKDROP = "DESTROY_BACKDROP";

  // Fetch product modality options (drug types)
  const fetchProductModalities = async () => {
    setLoadingDropdowns((prev) => ({ ...prev, modality: true }));
    try {
      const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchPlantDrugTypesDirect/true`;
      const response = await axios.get(url);

      if (response.data?.data?.status) {
        const drugTypeList = response.data?.data?.drugTypeList || [];
        setProductModalityOptions(drugTypeList);
      } else {
        console.error("Failed to fetch product modalities");
      }
    } catch (error) {
      console.error("Error fetching product modalities:", error);
    } finally {
      setLoadingDropdowns((prev) => ({ ...prev, modality: false }));
    }
  };

  // Fetch product type options
  const fetchProductTypes = async () => {
    setLoadingDropdowns((prev) => ({ ...prev, productType: true }));
    try {
      const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchProductTypes/true`;
      const response = await axios.get(url);

      if (response.data?.data?.status) {
        const productTypes = response.data?.data?.productTypeList || [];
        const activeProductTypes = productTypes.filter(
          (item) => item.activated === true
        );
      
        setProductTypeOptions(activeProductTypes);
      } else {
        console.error("Failed to fetch product types");
      }
    } catch (error) {
      console.error("Error fetching product types:", error);
    } finally {
      setLoadingDropdowns((prev) => ({ ...prev, productType: false }));
    }
  };

  const fetchBrandDetails = async (updatedFilters = filters, pageNumber = currentPage, pageSize = rowsPerPage, productIdPayloadOverride = productIdPayload) => {
    setLoading(true);
    setError(null);
    dispatch({ type: OPEN_BACKDROP });
    let searchVal = typeof updatedFilters.searchTerm === 'string' && updatedFilters.searchTerm === updatedFilters.searchTerm.trim() ? updatedFilters.searchTerm : updatedFilters.searchTerm.trim()
    try {
      const normalizeFilterValue = (value) => (value === "All" ? "all" : value);
      const requestObject = {
        searchField: updatedFilters.searchBy || "all",
        searchValue: searchVal || null,
        productModality: normalizeFilterValue(productIdPayloadOverride.productModalityId || filters.productModality),
        productType: normalizeFilterValue(productIdPayloadOverride.productTypeId || filters.productType),
        pageNumber,
        pageSize,
      };
      const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchBrandDetails`;
      const response = await axios.post(url, requestObject);
      if (response.data.status) {
        const result = response.data.data.brandsList || [];
        setProducts(result);
        setTotalPages(response.data.data.numberOfPages || 1);
        setTotalRecords(response.data.data.totalNoOfRecords || 0);
        setLastSyncTime(new Date());
      }
      dispatch({ type: DESTROY_BACKDROP });
    } catch (error) {
      setError("Something went wrong. Please try again.");
      dispatch({ type: DESTROY_BACKDROP });
    } finally {
      setLoading(false);
    }
  };
  // On component mount, fetch data and dropdown options
  useEffect(() => {
    const initializeFilters = async () => {
      try {
        // First fetch dropdown options in parallel
        const [modalitiesResponse, typesResponse] = await Promise.all([
          axios.get(`${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchPlantDrugTypesDirect/true`),
          axios.get(`${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchProductTypes/true`)
        ]);

        // Process and set dropdown options
        let modalityOptions = [];
        let typeOptions = [];

        if (modalitiesResponse.data?.data?.status) {
          modalityOptions = modalitiesResponse.data?.data?.drugTypeList || [];
          setProductModalityOptions(modalityOptions);
        }

        if (typesResponse.data?.data?.status) {
          const productTypes = typesResponse.data?.data?.productTypeList || [];
          typeOptions = productTypes.filter((item) => item.activated === true);
          setProductTypeOptions(typeOptions);
        }

        // Now restore filters
        const savedFilters = await fetchAllDashboardFilters('brandDetailsDashboard');
        let f = (savedFilters && savedFilters.data && savedFilters.data.brandDetailsDashboard) ? savedFilters.data.brandDetailsDashboard : null;
        
        let filtersToApply;
        if (!f || Object.keys(f).length === 0) {
          // No filters saved, set defaults
          filtersToApply = {
            searchBy: "",
            searchTerm: "",
            productModality: "All",
            productType: "All",
          };
        } else {
          filtersToApply = {
            searchBy: f.searchBy || "",
            searchTerm: f.searchTerm || "",
            productModality: f.productModality || "All",
            productType: f.productType || "All",
          };
        }

        // Resolve IDs from filter names using fetched options
        const productModalityId = filtersToApply.productModality === "All" 
          ? "all" 
          : modalityOptions.find((obj) => obj.drugTypeName === filtersToApply.productModality)?.drugTypeID || "all";

        const productTypeId = filtersToApply.productType === "All" 
          ? "all" 
          : typeOptions.find((obj) => obj.productTypeName === filtersToApply.productType)?.productTypeID || "all";

        const resolvedPayload = {
          productModalityId,
          productTypeId
        };

        // Update all states
        setFilters(filtersToApply);
        setLastSavedFilters(filtersToApply);
        setProductIdPayload(resolvedPayload);

        // Fetch data with resolved IDs
        fetchBrandDetails(filtersToApply, 1, rowsPerPage, resolvedPayload);
      } catch (e) {
        console.error("Error initializing filters:", e);
        // On error, set defaults
        const defaultFilters = {
          searchBy: "",
          searchTerm: "",
          productModality: "All",
          productType: "All",
        };
        setFilters(defaultFilters);
        setLastSavedFilters(defaultFilters);
        setProductIdPayload({ productModalityId: "all", productTypeId: "all" });
        fetchBrandDetails(defaultFilters, 1, rowsPerPage, { productModalityId: "all", productTypeId: "all" });
      }
    };
    
    initializeFilters();
    setInitialLoad(true);
  }, []);

  // Handle dropdown changes (immediately call API)
  const handleDropdownChange = (field) => (event) => {
    const newValue = event.target.value;
    // Create updated filters object with the new value
    const updatedFilters = {
      ...filters,
      [field]: newValue,
    };

    // console.log(
    //   productModalityOptions.find((obj) => obj.drugType === newValue),
    //   "ID-product"
    // );

    const productModalityId = productModalityOptions.find(
      (obj) => obj.drugTypeName === newValue
    )?.drugTypeID;

    const productTypeId = productTypeOptions.find(
      (obj) => obj.productTypeName === newValue
    )?.productTypeID;

    if (field === "productModality") {
      setProductIdPayload({ ...productIdPayload, productModalityId });
    } else if (field === "productType") {
      setProductIdPayload({ ...productIdPayload, productTypeId });
    }

    // Update state
    setFilters(updatedFilters);
    setPage(0); // Reset to first page
    
    // Pass updated filters and resolved product IDs
    const updatedProductIdPayload = field === "productModality" 
      ? { ...productIdPayload, productModalityId }
      : field === "productType"
      ? { ...productIdPayload, productTypeId }
      : productIdPayload;
    
    setTimeout(() => fetchBrandDetails(updatedFilters, 1, rowsPerPage, updatedProductIdPayload), 0);
  };

  // Handle search text changes (only updates state, no API call)
  const handleSearchChange = (e) => {
    let newValue = e.target.value;
    
    // Apply validation based on search type
    if (filters.searchBy === "Sponsor Product Code") {
      // Alphabets, Numbers (0-9), Hyphens (-), Underscore (_)
      const productCodeRegex = /^[A-Za-z0-9\-_]*$/;
      if (!productCodeRegex.test(newValue)) {
        return; // Don't update if invalid
      }
    } else if (filters.searchBy === "Sponsor Product Description") {
      // Alphabets, Spaces, Numbers (0-9), Hyphen(-), Point(.), Comma(,), slash(/), parentheses(), ampersand(&), colon(:)
      const productDescriptionRegex = /^[A-Za-z0-9 \-.,()&:/]*$/;
      if (!productDescriptionRegex.test(newValue)) {
        return; // Don't update if invalid
      }
    } else if (filters.searchBy === "CMO") {
      // Alphabets, Numbers (0-9), Spaces, Ampersand(&), Hyphen(-), Comma(,), Period(.), 
      // Forward slash(/), Apostrophes('), Parentheses()
      const cmoRegex = /^[A-Za-z0-9 &\-.,/'()]*$/;
      if (!cmoRegex.test(newValue)) {
        return; // Don't update if invalid
      }
    }
    
    setFilters((prev) => ({
      ...prev,
      searchTerm: newValue,
    }));
  };

  const handleSearchBlur = (e) => {
    let newValue = e.target.value;

    let trimmedValue = newValue.trim();
    // Apply validation based on search type
    if (filters.searchBy === "Sponsor Product Code") {
      // Alphabets, Numbers (0-9), Hyphens (-), Underscore (_)
      const productCodeRegex = /^[A-Za-z0-9\-_]*$/;
      if (!productCodeRegex.test(trimmedValue)) {
        return; // Don't update if invalid
      }
    } else if (filters.searchBy === "Sponsor Product Description") {
      // Alphabets, Spaces, Numbers (0-9), Hyphen(-), Point(.), Comma(,), slash(/), parentheses(), ampersand(&), colon(:)
      const productDescriptionRegex = /^[A-Za-z0-9 \-.,()&:/]*$/;
      if (!productDescriptionRegex.test(trimmedValue)) {
        return; // Don't update if invalid
      }
    } else if (filters.searchBy === "CMO") {
      // Alphabets, Numbers (0-9), Spaces, Ampersand(&), Hyphen(-), Comma(,), Period(.), 
      // Forward slash(/), Apostrophes('), Parentheses()
      const cmoRegex = /^[A-Za-z0-9 &\-.,/'()]*$/;
      if (!cmoRegex.test(trimmedValue)) {
        return; // Don't update if invalid
      }
    }
    
    setFilters((prev) => ({
      ...prev,
      searchTerm: trimmedValue,
    }));
  }; 
  // Handle onInput for real-time character validation
  const handleSearchInput = (e) => {
    const inputValue = e.target.value;
    
    // Apply validation based on search type
    if (filters.searchBy === "Sponsor Product Code") {
      const productCodeRegex = /^[A-Za-z0-9\-_]*$/;
      if (!productCodeRegex.test(inputValue)) {
        e.preventDefault();
        e.target.value = filters.searchTerm;
        return false;
      }
    } else if (filters.searchBy === "Sponsor Product Description") {
      const productDescriptionRegex = /^[A-Za-z0-9 \-.,()&:/]*$/;
      if (!productDescriptionRegex.test(inputValue)) {
        e.preventDefault();
        e.target.value = filters.searchTerm;
        return false;
      }
    } else if (filters.searchBy === "CMO") {
      const cmoRegex = /^[A-Za-z0-9 &\-.,/'()]*$/;
      if (!cmoRegex.test(inputValue)) {
        e.preventDefault();
        e.target.value = filters.searchTerm;
        return false;
      }
    }
  };
  //
  // Handle search by dropdown change (only updates state, no API call)
  const handleSearchByChange = (event) => {
    const newValue = event.target.value;
    setFilters((prev) => ({
      ...prev,
      searchBy: newValue,
    }));
  };

  const handleClearFilters = async () => {
    const defaultFilters = {
      searchBy: "",
      searchTerm: "",
      productModality: "All",
      productType: "All",
    };

    // Show backdrop loader and clearing state first
    setClearingFilters(true);
    dispatch({ type: OPEN_BACKDROP });

    // Cleared product IDs
    const clearedProductIdPayload = { productModalityId: "all", productTypeId: "all" };

    // Update state
    setFilters(defaultFilters);
    setProductIdPayload(clearedProductIdPayload);
    setCurrentPage(1);

    try {
      // Call fetchBrandDetails with default filters and cleared product IDs
      fetchBrandDetails(defaultFilters, 1, rowsPerPage, clearedProductIdPayload);
    } catch (e) {
      console.error("Error clearing filters:", e);
    } finally {
      // Hide backdrop loader and clearing state
      setClearingFilters(false);
      dispatch({ type: DESTROY_BACKDROP });
    }
  };

  const handleSaveFilter = async () => {
    const filtersToSave = {
      searchBy: filters.searchBy,
      searchTerm: filters.searchTerm,
      productModality: filters.productModality,
      productType: filters.productType,
    };
    
    // Show backdrop loader and button loading state
    setSavingFilters(true);
    dispatch({ type: OPEN_BACKDROP });
    
    try {
      await saveDashboardFilters('brandDetailsDashboard', filtersToSave);
      setSaveDialogSuccess(true);
      setSaveDialogOpen(true);
      setLastSavedFilters(filtersToSave);
    } catch (error) {
      setSaveDialogSuccess(false);
      setSaveDialogOpen(true);
    } finally {
      // Hide backdrop loader and button loading state
      setSavingFilters(false);
      dispatch({ type: DESTROY_BACKDROP });
    }
  };

  const filtersChanged = () => {
    return (
      filters.searchBy !== lastSavedFilters.searchBy ||
      filters.searchTerm !== lastSavedFilters.searchTerm ||
      filters.productModality !== lastSavedFilters.productModality ||
      filters.productType !== lastSavedFilters.productType
    );
  };

  const handleRefresh = () => {
    setLastSyncTime(new Date());
    fetchBrandDetails();
    fetchProductModalities();
    fetchProductTypes();
  };

  const handleSearch = () => {
    fetchBrandDetails();
  };

  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    setCurrentPage(1);
    fetchBrandDetails(filters, 1, newRowsPerPage);
  };

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage);
      fetchBrandDetails(filters, newPage, rowsPerPage);
    }
  };

  const toggleExpand = (brand) => {
    setExpandedProducts((prev) => ({
      ...prev,
      [brand]: prev[brand] === undefined ? true : !prev[brand],
    }));
  };

  // Group brandDetailsList by productTypeID and get productTypeName from productTypeOptions
  const groupByProductType = (brandDetailsList, productTypeOptions) => {
    const typeIdToName = Object.fromEntries(
      (productTypeOptions || []).map(opt => [opt.productTypeID, opt.productTypeName])
    );
    const grouped = {};
    for (const item of brandDetailsList || []) {
      const typeName = typeIdToName[item.productTypeID] || item.productTypeID;
      if (!grouped[typeName]) grouped[typeName] = [];
      grouped[typeName].push(item);
    }
    return grouped;
  };

  return (
    <Box p={3}>
      {/* Search Filters */}
      <Grid
        container
        spacing={2}
        alignItems="center"
        style={{ marginBottom: 20 }}
      >
        <Grid item xs={4}>
          <Box display="flex" className="select-search-by-field">
            <FormControl
              variant="outlined"
              size="small"
              className={classes.formControl}
            >
              <Select
                id="search-by"
                value={filters.searchBy}
                onChange={handleSearchByChange}
                displayEmpty
                renderValue={(selected) => {
                  if (!selected) return "Select Search By";
                  const option = searchByOptions.find(
                    (opt) => opt.value === selected
                  );
                  return option ? option.label : selected;
                }}
                className={`select-search ${classes.select}`}
                IconComponent={ArrowDropDown}
              >
                <MenuItem value="">Select Search By</MenuItem>
                {searchByOptions.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <Box display="flex" flexGrow={1}>
              <TextField
                fullWidth
                variant="outlined"
                size="small"
                placeholder="Search"
                value={filters.searchTerm}
                onInput={handleSearchInput}
                onChange={handleSearchChange}
                onBlur={handleSearchBlur}
                disabled={!filters.searchBy}
                onKeyPress={(e) => {
                  if (e.key === "Enter" && filters.searchBy) {
                    handleSearch();
                  }
                }}
                InputProps={{
                  style: { paddingRight: 0, height: 40, width: 500 },
                  endAdornment: (
                    <Button
                      variant="contained"
                      className={classes.searchButton}
                      onClick={handleSearch}
                      disabled={!filters.searchBy}
                    >
                      <SearchIcon style={{ color: !filters.searchBy ? "#ccc" : "#fff" }} />
                    </Button>
                  ),
                }}
                className={`search-textbox ${classes.textField}`}
              />
            </Box>
          </Box>
        </Grid>
      </Grid>

      {/* Filter Controls */}
      <Grid container spacing={2} style={{ marginBottom: 20 }}>
        {/* Left side filters */}
        <Grid item xs={12} md={8}>
          <Grid container spacing={2}>
            {/* Product Modality */}
            <Grid item xs={12} sm={6} md={3}>
              <Box display="flex" flexDirection="column">
                <Typography className="dashboard-filter-labels">
                  Product Modality:
                </Typography>
                <FormControl
                  variant="outlined"
                  size="small"
                  className={`dashboard-filter-dropdown ${classes.filterSelect}`}
                >
                  <Select
                    value={filters.productModality}
                    onChange={handleDropdownChange("productModality")}
                    disabled={loadingDropdowns.modality}
                  >
                    <MenuItem value="All">All</MenuItem>
                    {productModalityOptions.filter((option) => option.drugTypeName !== "").map((option) => (
                      <MenuItem
                        key={option.drugTypeID || option}
                        value={option.drugTypeName || option}
                      >
                        {option.drugTypeName || option}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
            </Grid>

            {/* Product Type */}
            <Grid item xs={12} sm={6} md={3}>
              <Box display="flex" flexDirection="column">
                <Typography className="dashboard-filter-labels">
                  Product Type:
                </Typography>
                <FormControl
                  variant="outlined"
                  size="small"
                  className={`dashboard-filter-dropdown ${classes.filterSelect}`}
                >
                  <Select
                    value={filters.productType}
                    onChange={handleDropdownChange("productType")}
                    disabled={loadingDropdowns.productType}
                  >
                    <MenuItem value="All">All</MenuItem>
                    {productTypeOptions.map((option) => (
                      <MenuItem
                        key={option.productTypeID || option}
                        value={option.productTypeName || option}
                      >
                        {option.productTypeName || option}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
            </Grid>

            {/* Save filters and Clear filters - aligned horizontally */}
            <Grid item xs={12} md={6}>
              <Box
                display="flex"
                alignItems="flex-end"
                style={{ height: "100%" }}
              >
                <Button
                  variant="contained"
                  className={classes.saveFiltersButton}
                  onClick={handleSaveFilter}
                  disabled={!filtersChanged() || savingFilters}
                  startIcon={savingFilters ? <CircularProgress size={16} color="inherit" /> : null}
                >
                  {savingFilters ? 'Saving...' : 'Save filters'}
                </Button>
                <Box ml={2}>
                  <Typography
                    className={classes.clearFilters}
                    onClick={clearingFilters ? null : handleClearFilters}
                    style={{ 
                      cursor: clearingFilters ? 'not-allowed' : 'pointer',
                      opacity: clearingFilters ? 0.6 : 1,
                      pointerEvents: clearingFilters ? 'none' : 'auto'
                    }}
                  >
                    {clearingFilters ? 'Clearing...' : 'Clear all filters'}
                  </Typography>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Grid>

        {/* Right side - Last synced and per page */}
        <Grid item xs={12} md={4}>
          <Box display="flex" flexDirection="column" alignItems="flex-end">
            <Box display="flex" alignItems="center" mb={1}>
              <Typography
                variant="body2"
                className="last-synced-text"
              >
                {`Last Synced @ ${moment(lastSyncTime).format(
                  "HH:mm:ss; DD MMMM, YYYY"
                )}`}
              </Typography>
              <Typography
                variant="body2"
                color="primary"
                className="refresh-button"
                onClick={handleRefresh}
              >
                Refresh
                <Refresh color="primary" fontSize="small" />
              </Typography>
            </Box>
            <Box display="flex" alignItems="center" className="per-page-box">
              <Typography style={{ fontWeight: "bold", marginRight: "8px" }}>
                PER PAGE
              </Typography>
              <FormControl variant="outlined" size="small">
                <Select value={rowsPerPage} onChange={handleChangeRowsPerPage}>
                  <MenuItem value={5}>5</MenuItem>
                  <MenuItem value={10}>10</MenuItem>
                  <MenuItem value={15}>25</MenuItem>
                </Select>
              </FormControl>
            </Box>
          </Box>
        </Grid>
      </Grid>

      {/* Table with loading state */}
      <TableContainer component={Paper} className="default-table-styles">
        <Table className="default-table-styles">
          <TableHead>
            <TableRow className={classes.tableHeader}>
              <TableCell width="40px"></TableCell>
              <TableCell>Brand</TableCell>
              <TableCell>Associated Sponsor Team Members</TableCell>
              <TableCell>Product Type</TableCell>
              <TableCell>Product Code / Description</TableCell>
              <TableCell>CMO</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={6}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "100px",
                    }}
                  >
                    <CircularProgress />
                  </div>
                </TableCell>
              </TableRow>
            ) : error ? (
              <TableRow>
                <TableCell colSpan={6}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "50px",
                      border: "2px solid #FF0000",
                      backgroundColor: "#FFF0F0",
                      width: "100%",
                    }}
                  >
                    <Typography style={{ textAlign: "center" }}>
                      {error}
                    </Typography>
                  </div>
                </TableCell>
              </TableRow>
            ) : products.length === 0 ? (
              <TableRow>
                <TableCell colSpan={6} align="center">
                  No records found.
                </TableCell>
              </TableRow>
            ) : (
              products.map((product) => {
                return (<React.Fragment key={product.brand}>
                  <TableRow>
                    <TableCell>
                      <IconButton
                        className={classes.expandButton}
                        onClick={() => toggleExpand(product.brand)}
                      >
                        {expandedProducts[product.brand] ? (
                          <KeyboardArrowDown />
                        ) : (
                          <KeyboardArrowRight />
                        )}
                      </IconButton>
                    </TableCell>
                    <TableCell>{product.brand}</TableCell>
                    <TableCell
                      style={{
                        color: "blue",
                        textDecoration: "underline",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        setSelectedBrand(product.brand);
                        setSelectedTeamMembers(product.associatedSponsorTeamMembers || []);
                        setTeamDrawerOpen(true);
                      }}
                    >
                      {product.associatedSponsorTeamMembers.length} Team Members
                    </TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                  {expandedProducts[product?.brand] &&
                    product?.brandDetailsList.length > 0 &&
                    Object.entries(groupByProductType(product.brandDetailsList, productTypeOptions)).map(
                      ([productType, details]) =>
                        details.map((detail, detailIndex) => (
                          <TableRow key={`${product.brand}-${productType}-${detailIndex}`}>
                            <TableCell></TableCell>
                            <TableCell>{product.brand}</TableCell>
                            <TableCell></TableCell>
                            <TableCell>{productType}</TableCell>
                            <TableCell>
                              {detail.productCode} / {detail.productDescription}
                            </TableCell>
                            <TableCell>{detail.vendorName}</TableCell>
                          </TableRow>
                        ))
                    )}
                </React.Fragment>)
                })
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Pagination */}
      <Box display="flex" justifyContent="center" alignItems="center" mt={2}>
        <IconButton
          size="small"
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          <ChevronLeft fontSize="small" />
        </IconButton>
        <Typography variant="body2" style={{ margin: "0 8px" }}>
          {`Page ${currentPage} of ${totalPages}`}
        </Typography>
        <IconButton
          size="small"
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage >= totalPages}
        >
          <ChevronRight fontSize="small" />
        </IconButton>
      </Box>

      {/* Save Dialog */}
      <Dialog open={saveDialogOpen} onClose={() => setSaveDialogOpen(false)} fullWidth maxWidth="sm">
        <StyledDialog
          title={saveDialogSuccess ? 'Saved successfully' : 'Failed to save filters'}
          subtitle={saveDialogSuccess ? 'Filters saved successfully!' : 'Failed to save filters.'}
          icon={!saveDialogSuccess} // false = check, true = cross
          handleClose={() => setSaveDialogOpen(false)}
          noCloseButton={true}
        />
      </Dialog>

      {/* Team Members Drawer */}
      <Drawer anchor="right" open={teamDrawerOpen} onClose={() => setTeamDrawerOpen(false)}>
        <div className={classes.drawer}>
          <div className={classes.drawerHeader}>
            <Typography className={classes.drawerTitle}>
              {selectedBrand}
            </Typography>
          </div>
          <Divider />
          <div className={classes.drawerContent}>
            <Typography className={classes.drawerSubtitle} style={{fontWeight: "bold"}}>
              Associated Sponsor Team Members
            </Typography>
            <List style={{ padding: 0 }}>
              {selectedTeamMembers.length > 0 ? (
                selectedTeamMembers.map((member, index) => (
                  <ListItem key={index} className={classes.memberItem}>
                    <Avatar className={classes.avatar}>
                      {member.userName
                        ? member.userName.split(" ").map(n => n[0]).join("").toUpperCase()
                        : "NM"}
                    </Avatar>
                    <div className={classes.memberInfo}>
                      <Typography className={classes.memberName} style={{ fontWeight: 'bold' }}>
                        {member.userName || ""}
                      </Typography>
                      <Typography className={classes.memberRole}>
                      {member.collaboratorRoleName || "Team Member"} - {member.departmentName}
                      </Typography>
                      <Typography className={classes.memberRole}>
                       {member.productTypesList.map((product, idx) => (
                         <span key={idx}>
                           {product.productTypeName}
                           {idx < member.productTypesList.length - 1 && ", "}
                         </span>
                       ))}
                      </Typography>
                    </div>
                  </ListItem>
                ))
              ) : (
                <Typography>No team members found.</Typography>
              )}
            </List>
          </div>
          <div className={classes.drawerFooter}>
            <Button
              variant="contained"
              onClick={() => setTeamDrawerOpen(false)}
              className={classes.drawerCloseButton}
            >
              Close
            </Button>
          </div>
        </div>
      </Drawer>
    </Box>
  );
};

export default BrandDetails;
